import React from 'react';
import ChatPage from './pages/ChatPage';
import './App.css';

function App() {
  return (
    <div className="App">
      <ChatPage />
    </div>
  );
}

export default App;
